import produce from 'immer'
import constants from 'constants/dashboards'

const initialState = {
  dashboards: [],
  fetching: false,
  doneFetching: false,
  fetchError: ''
}

export default produce((draft, action) => {
  switch (action.type) {
    case constants.FETCH_DASHBOARDS_REQUEST:
      draft.fetching = true
      draft.doneFetching = false
      break
    case constants.FETCH_DASHBOARDS_SUCCESS:
      draft.fetching = false
      draft.doneFetching = true
      draft.fetchError = ''
      draft.dashboards = action.dashboards
      break
    case constants.FETCH_DASHBOARDS_FAILURE:
      draft.fetching = false
      draft.doneFetching = true
      draft.fetchError = action.errorMessage
      break
  }
}, initialState)
